import React, { useState } from 'react';
import {
  Typography,
  Box,
  CircularProgress,
  Backdrop,
  Paper,
} from '@mui/material';
import NameChecker from '../name_checker';

const CompanyChecker = () => {
  const [loading, setLoading] = useState(false);

  return (
    <Box align="center" sx={{ pt: 4, pb: 4 }}>
      <Typography
        variant="h3"
        component="h1"
        gutterBottom
        sx={{
          fontWeight: 'bold',
          //color: (theme) => theme.palette.secondary.main,
        }}
        mb={0}
      >
        Build Your Dream Business Hassle-Free!
      </Typography>
      <Typography variant="body1" gutterBottom>
        Starting a business? You can quickly and effortlessly register your
        Limited Company.
      </Typography>
      <Typography variant="body1" gutterBottom>
        Get started today and set your business on the path to success with our
        streamlined registration process. Simple, efficient, and hassle-free!
      </Typography>
      <Box mt={4}>
        <Paper elevation={12} square={false} sx={{ p: 2.5 }}>
          <Typography variant="h6" align="left" mb={1}>
            Enter your company name to check the availability
          </Typography>
          <NameChecker
            label={'Company Name'}
            loading={loading}
            setLoading={setLoading}
          />
        </Paper>
      </Box>

      {/* {isRegistered !== null && !loading && (
        <Box mt={4}>
          {isRegistered ? (
            <Typography variant="h6" color={"error"}>
              The company name "{companyNameSearched}" is already registered.
            </Typography>
          ) : (
            <Typography variant="h6" color={"success"}>
              The company name "{companyNameSearched}" is available.
            </Typography>
          )}
        </Box>
      )} */}
      <Backdrop open={loading} style={{ zIndex: 9999, color: '#fff' }}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
};

export default CompanyChecker;
